module.exports = __webpack_public_path__ + "static/media/career-laptop.6153af33.svg";